import { getCountryConfiguration } from '../hooks/useTenantConfigs'
import { STORAGE_COMPANY_KEY, STORAGE_COUNTRY_KEY } from './auth'
import { remoteConfig } from './firebaseConfig'
import { getObjectInStorage } from '../hooks/useStorage'

export const getConfigsMFEFirebase = (key) => {
  const country = localStorage.getItem(STORAGE_COUNTRY_KEY) || getObjectInStorage('@naturaReports:auth')?.country
  const company = Number(localStorage.getItem(STORAGE_COMPANY_KEY)) || getObjectInStorage('@naturaReports:auth')?.company

  const {
    country: { alpha3Code },
    company: { name },
  } = getCountryConfiguration(company, country)

  const firebaseConfigsAllMFE = remoteConfig.getValue('REGISTER_REPORTS_MFE_AUTH_TOGGLE')
  return key ? JSON.parse(firebaseConfigsAllMFE.asString())[name][alpha3Code][key] : {}
}
